export const joinIfPresent = (
    values: (string | undefined)[],
    separator: string,
): string | undefined => {
    const nonEmptyValues = values.filter((value) => !!value);

    if (!nonEmptyValues.length) {
        return undefined;
    }

    return nonEmptyValues.join(separator);
};
